import React from 'react';

import { CampaignManager } from '../CampaignManager/CampaignManager';

export const CampaignManagerPage: React.FC = () => <CampaignManager />;
